/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
} from "@mui/material";
import { Table } from "reactstrap";
import "./lead-qualification-merge-lead-exact-matching.scss";
import { getLeads } from "../../../../api/lead";
import { useLogin } from "../../../../common/hooks/useUser";
import { PaginationComponent } from "../../../../common/components";
import  RenderCellContent from "../../../../common/components/mui-table/render-cell-content";
import LeadsStatus from "../../lead-qualification-leads-status";
import icons from "../../../../assets/icons/icons";
import downArrowIcons from "../../../../assets/icons/down_arrow.svg";
import LeadQualificationMergeConfirmationPopups from "../../lead-qualification-popups/lead-qualification-merge-confirmation-popups/lead-qualification-merge-confirmation-popups";
import { isValidPhoneNumber } from "../../../../utils/utils";

const LeadQualificationMergeLeadExactMatching: any = (props: any) => {
  const {
    setLoading,
    setAlertMessage,
    setAlertType,
    setAlertOpen,
    payload,
  } = props;
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize] = useState<number>(10);
  const [data, setData] = useState<any[]>([]);
  const [selectedLeadId, setSelectedLeadId] = useState<any[]>([]);
  const [expandedRowId, setExpandedRowId] = useState<string | null>(null);
  const [isShowConfirmMergePopup, setIsShowConfirmMergePopup] =
    useState<boolean>(false);

  const userDetails = useLogin();

  const leadOwner =
    userDetails?.userDetails?.firstName +
    " " +
    userDetails?.userDetails?.lastName;

  const fetchLeads = async (
    page = 1,
    search: string = "",
  ) => {
    setLoading(true);
    try {
      const offset = (page - 1) * pageSize;
      const params: any = {
        limit: pageSize,
        offset: offset,
        exactMatching:true
      };
      if (search) {
        params.searchText = search;
      }
      const response = await getLeads(params);
      setData(response.data.data.groups);
      setTotalRecords(response?.data?.data?.totalCount);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to fetch campaigns"
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  useEffect(() => {
      fetchLeads( currentPage, "");
  }, [currentPage, payload]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };

  const headers = [
    { key: "expand", label: "Expand", isSortable: false },
    { key: "duplicates", label: "Duplicate Found", isSortable: false },
    { key: "leadName", label: "Lead Name", isSortable: true },
    { key: "email", label: "Email", isSortable: true },
    { key: "phone", label: "Phone Number", isSortable: true },
    { key: "leadSource", label: "Lead Source", isSortable: true },
    { key: "leadOwner", label: "Lead Owner", isSortable: true },
    { key: "leadStatus", label: "Lead Status", isSortable: true },
    { key: "merge", label: "Merge Action", isSortable: false },
  ];

  const fetchFullName = (item: any) => {
    const firstName = item?.first_name?.trim();
    const lastName = item?.last_name?.trim();
    const fullName =
      firstName && lastName
        ? `${firstName} ${lastName}`
        : firstName
          ? firstName
          : lastName
            ? lastName
            : "-";
    return fullName;
  };

  const formattedData = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((item) => {
        const mainItems: any= item?.duplicates?.length > 1 ? item?.duplicates[0] : [];
        const firstName =  mainItems?.first_name?.trim();
        const lastName = mainItems?.last_name?.trim();
        const middleName =  mainItems?.middle_name ?  mainItems?.middle_name?.trim() : "";
        const fullName =
          firstName && lastName
            ? `${firstName ? `${firstName} `:""}${middleName ? `${middleName} `:""}${lastName}`
            : firstName || middleName || lastName || "-";
        const isExpanded = expandedRowId ===  mainItems.id;

        const leadName = fullName;
        const leadOwnerName = fetchFullName( mainItems?.owner);
        const createdBy = fetchFullName( mainItems?.createdBy);

        const duplicatesInnerLeads =  item?.duplicates?.filter((data: any, index: any)=> index !== 0) || [];
        const selectedLeadIdInfo = [mainItems.id];
        return {
          id: mainItems.id,
                              expand: (
                      <img
                        src={
                          isExpanded ? icons.ExpandUpArrow : icons.ExpandDownArrow
                        }
                        alt={isExpanded ? "Collapse" : "Expand"}
                        className="expand-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          setExpandedRowId((prevId) =>
                            prevId === mainItems.id ? null : mainItems.id
                          );
                        }}
                      />
                    ),
          isExpandedInfo: isExpanded,
          leadName: leadName,
          duplicates: item?.duplicateCount || 0,
          duplicatesData: duplicatesInnerLeads.map((duplicateItem: any) => {
            const duplicateFirstName = duplicateItem.first_name?.trim();
            const duplicateLastName = duplicateItem.last_name?.trim();
            const duplicateMiddleName = duplicateItem?.middle_name ? duplicateItem?.middle_name?.trim() : "";     
            const duplicateFullName =
              duplicateFirstName && duplicateLastName
                ? `${duplicateFirstName ? `${duplicateFirstName} `:""}${duplicateMiddleName ? `${duplicateMiddleName} `:""}${duplicateLastName}`
                : duplicateFirstName || duplicateMiddleName || duplicateLastName || "-";
                selectedLeadIdInfo.push(duplicateItem.id);
            return {
              expand:" ",
              duplicates: " ",
              id: duplicateItem.id,
              leadName: duplicateFullName,
              email: duplicateItem.primary_email_address || "-",
              phone: isValidPhoneNumber(duplicateItem.primary_phone_number) ? duplicateItem.primary_phone_number : "-",
              leadSource: duplicateItem.lead_source || "-",
              leadOwner: fetchFullName(duplicateItem?.owner) || "-",
              leadStatus: <LeadsStatus status={duplicateItem.lead_status} />,
              merge:" "
            };
          }),
          email:  mainItems?.primary_email_address || "-",
          phone:  isValidPhoneNumber(mainItems?.primary_phone_number) ? mainItems?.primary_phone_number : "-",
          leadSource:  mainItems?.lead_source || "-",
          leadOwner: leadOwnerName,
          leadCreatedBy: createdBy,
          leadStatus: <LeadsStatus status={ mainItems?.lead_status} />,
                    merge: (
                      <button
                        type="button"
                        className="lead-qualification-merge-lead-fuzzy-matching-table-button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setIsShowConfirmMergePopup(true);
                          setSelectedLeadId(selectedLeadIdInfo);
                        }}
                      >
                        Merge
                      </button>
                    ),
        };
      });
    }
    return [];
  }, [data, leadOwner, expandedRowId]);

  const getTextContent = (value: any): string | React.ReactNode => {
    if (!value) return "-";

    if (typeof value === "string") {
      return (
        <span className="table-cell-content" title={value}>
          {value}
        </span>
      );
    }

    if (React.isValidElement(value)) {
      const { props }: any = value;

      if (props.status || typeof value.type === "function") {
        return (
          <span
            className="table-cell-content clickable"
            title={props.status || props.children}
          >
            {value}
          </span>
        );
      }

      // For clickable React elements
      if (
        (props.onClick || typeof value.type === "function") &&
        !props.status
      ) {
        return (
          <span
            className="table-cell-content clickable"
            title={props.children || "Click"}
          >
            {value}
          </span>
        );
      }

      // Handle mixed children (text + React elements)
      if (Array.isArray(props.children)) {
        return (
          <span
            className="table-cell-content"
            title={props.children
              .map((child: any) => (typeof child === "string" ? child : ""))
              .join(" ")}
          >
            {props.children.map((child: any, index: number) =>
              typeof child === "string" ? child : child
            )}
          </span>
        );
      }

      return value;
    }

    if (typeof value === "number") {
      return (
        <span className="table-cell-content" title={value.toString()}>
          {value}
        </span>
      );
    }

    return "N/A";
  };

  return (
    <>
      <div
        className="lead-qualification-merge-lead-fuzzy-matching"
      >
        <div className="lead-qualification-merge-lead-fuzzy-matching-table-pagination">
            <div className="results-text-and-table-container">
              <div className="lead-qualification-merge-lead-fuzzy-matching-header">
                <div className="lead-qualification-merge-lead-fuzzy-matching-header-main-text">
                  Result
                </div>
                <div className="lead-qualification-merge-lead-fuzzy-matching-header-sub-text">
                  Click the{" "} <img src={downArrowIcons} alt="downArrowIcons"/>{" "} to expand and view all exact duplicates in the group.
                </div>
              </div>
              <div className="lead-qualification-merge-lead-fuzzy-matching-table">
                <div className="mui-table exact-matching-table">
                  <div className="table-container">
                    <Table striped={true} className="custom-table-wraper">
                      <thead>
                        <tr>
                          {headers.map((header: any) => (
                            <th
                              key={header.key}
                              style={{ width: header?.fixedColumnWidth ?? "" }}
                            >
                              <div className="header-cell">
                                <div className="header-text">
                                    {header.label}
                                </div>
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {formattedData?.length ? (
                          formattedData.map((row: any, rowIndex: number) => (
                            <>
                            <tr
                              key={rowIndex}
                            >
                              {headers.map((header: any, colIndex: number) => (
                                <td
                                  key={colIndex}
                                >
                                    <span
                                      className={`${header?.isOnClick ? "table-cell-pointer" : ""}`}
                                    >
                                      <RenderCellContent
                                        text={getTextContent(row[header?.key])}
                                      />
                                    </span>
                                </td>
                              ))}
                            </tr>
                            {row?.id === expandedRowId ?
                            row?.duplicatesData?.length ? (
                                row?.duplicatesData?.map((duplicatesDataRow: any, duplicatesDataRowIndex: number) => {
                                  return (
                                  <tr
                                    key={duplicatesDataRowIndex}
                                    className= "lead-qualification-merge-lead-fuzzy-matching-table-expanded-row"
                                  >
                                    {headers.map((header: any, duplicatesDataColIndex: number) => (
                                      <td
                                        key={duplicatesDataColIndex}
                                      >
                                          <span
                                          >
                                            <RenderCellContent
                                              text={getTextContent(duplicatesDataRow[header?.key])}
                                            />
                                          </span>
                                      </td>
                                    ))}
                                  </tr>)

                                })) :<tr className="no-data-row">
                              <td colSpan={headers?.length}>
                                <Box sx={{ textAlign: "center" }}>
                                  { "No data found"}
                                </Box>
                              </td>
                            </tr>:""}
                            </>

                          ))
                        ) : (
                          <tr className="no-data-row">
                            <td colSpan={headers?.length}>
                              <Box sx={{ textAlign: "center" }}>
                                { "No data found"}
                              </Box>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
              {totalRecords && totalRecords > 0 ? (
                <div className="leads-pagination-containers">
                  <PaginationComponent
                    totalRecords={totalRecords}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
        </div>
        {isShowConfirmMergePopup && (
          <LeadQualificationMergeConfirmationPopups
            setIsShowConfirmMergePopup={setIsShowConfirmMergePopup}
            isShowConfirmMergePopup={isShowConfirmMergePopup}
                setAlertMessage={setAlertMessage}
                setAlertType={setAlertType}
                setAlertOpen={setAlertOpen}
                setLoading={setLoading}
                selectedLeadId={selectedLeadId}
                fetchLeads={fetchLeads}
                setSelectedLeadId={setSelectedLeadId}
          />
        )}
      </div>
    </>
  );
};

export default LeadQualificationMergeLeadExactMatching;